module.exports = __webpack_public_path__ + "img/hot.ab15cc17.png";